module.exports = __webpack_public_path__ + "img/file.644eff2a.svg";